
const init = {
    getListParams: {
        page_index: 1,
        page_size: 20,
        is_activated: '',
        terminate_sign: '',
        project_name: ''
    },
    cooperationList: [],
    pageCount: 0
}
function shopData(prevState = init, action) {
    switch (action.type) {
        case 'SAVE_SHOP_LIST':
            return action.data;
        default:
            return prevState;
    }
}

function currentTag(prevState = false, action) {
    switch (action.type) {
        case 'CHANGE_TAG':
            return action.data;
        default:
            return prevState;
    }
}
const initStatus = {
    currentSelect: '全部',
    is_activated: '',
    terminate_sign: ''
}
function currentSelectStatus(prevState = initStatus, action) {
    switch (action.type) {
        case 'SELECT_STATUS':
            return action.data;
        default:
            return prevState;
    }
}

export default { shopData, currentTag, currentSelectStatus };


// WEBPACK FOOTER //
// ./src/rootRedux/reducers/shopList.js